import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { putOccupation } from "../../connections/putOccupation";

const UpdateOccupations = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const location = useLocation();
  const occupationsData = location.state || null;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "" || occupationsData?.title,
    value: "" || occupationsData?.value,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form data at submission:", formData);
    if (!formData.title || !formData.value) {
      toast.error("Title and value is required");
      return;
    }
    const payload = {
      occupation: formData,
    };

    try {
      const result = await putOccupation(
        user?.token,
        payload,
        occupationsData?.id
      );
      if (result?.status?.status === "SUCCESS") {
        toast.success("Occupation Updated Successfully");
        navigate(-1);
        setFormData({
          title: "",
          value: "",
        });
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="occupation-list" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={-1}>Occupation</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Update Occupation</li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    {occupationsData?.id}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Occupations</h4>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Title
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="form-control"
                            type="text"
                            required={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Value
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            name="value"
                            value={formData.value}
                            onChange={handleChange}
                            className="form-control"
                            type="text"
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                          >
                            Update Occupation
                          </button>
                          <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="btn btn-primary cancel-form"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateOccupations;
